/**
 * Creates a comparator function for sorting grid columns.
 * Handles null/undefined values, numbers, and strings.
 *
 * @param {string} sortColumn - The column key to sort by
 * @returns {Function} A comparator function that can be used with Array.sort()
 *
 * @example
 * const comparator = getComparator('tagName');
 * const sorted = rows.sort(comparator);
 */
export const getComparator = (sortColumn) => {
  return (a, b) => {
    const aVal = a[sortColumn];
    const bVal = b[sortColumn];

    if (aVal == null && bVal == null) return 0;
    if (aVal == null) return -1;
    if (bVal == null) return 1;

    if (typeof aVal === "number" && typeof bVal === "number") {
      return aVal - bVal;
    }

    return String(aVal).localeCompare(String(bVal));
  };
};
